import React from 'react';
import './Carousel.css';
import photo from './CarouselMedia/gl-logo.png';
import poster from './CarouselMedia/host.jpg';
import img00 from './CarouselMedia/0001.jpg';
import img0 from './CarouselMedia/001.jpg';
import img1 from './CarouselMedia/1.jpg';
import img2 from './CarouselMedia/2.jpg';
import img3 from './CarouselMedia/3.jpg';
import img4 from './CarouselMedia/4.jpg';
import img5 from './CarouselMedia/5.jpg';
import img6 from './CarouselMedia/6.jpg';
import img7 from './CarouselMedia/7.jpg';
import img8 from './CarouselMedia/8.jpg';
import img9 from './CarouselMedia/9.jpg';
import img10 from './CarouselMedia/10.jpg';
import img11 from './CarouselMedia/11.jpg';
import img12 from './CarouselMedia/12.jpg';
import img13 from './CarouselMedia/13.jpg';
import img14 from './CarouselMedia/14.jpg';
import img15 from './CarouselMedia/15.jpg';
import img16 from './CarouselMedia/16.jpg';
import img17 from './CarouselMedia/17.jpg';
import img18 from './CarouselMedia/18.jpg';
import img19 from './CarouselMedia/19.jpg';
import img20 from './CarouselMedia/20.jpg';
import img21 from './CarouselMedia/21.jpg';
import img22 from './CarouselMedia/22.jpg';
import img23 from './CarouselMedia/23.jpg';
import img24 from './CarouselMedia/24.jpg';
import img25 from './CarouselMedia/25.jpg';
import img26 from './CarouselMedia/26.jpg';
import CarouselModal from './CarouselModal.js';


export class Carousel extends React.Component {
    constructor(props) {
        super(props);

    
        this.state = {
          showModal: false,
          CarouselTimer: 4000,
          path: photo,
          currentPhoto: poster,
          imgList: [poster, img00, img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20, img21, img22, img23, img24, img25, img26],
          prevSelectedArr: []
        };

        //BINDINGS
        this.getPhoto = this.getPhoto.bind(this);
        this.modalPop = this.modalPop.bind(this);
      }
 
      //Runs setInterval just as the component is rendered. Only executed once.
componentWillMount(){
  this.intervalId = setInterval(this.getPhoto, this.state.CarouselTimer); 
 }
 
 componentWillUnmount()
 {
   clearInterval(this.intervalId); //We stop the interval
 }
 
 componentDidUpdate()
 {
   //Restart interval on each update to keep timer in sync
   clearInterval(this.intervalId);
   this.intervalId = setInterval(this.getPhoto,  this.state.CarouselTimer); 
 }

 modalPop(e){ //Trigger App's modal component... Toggles showModal true or false
 if (this.state.showModal === false)
 {
 this.setState({showModal: true})
 }
 else{
   this.setState({showModal: false})
 }
}


//Gets a random photo from the photo array
getPhoto()
{  
  let selectedPhoto = this.state.currentPhoto;

  //We loop to never get the same twice in a row

  
  
  while(selectedPhoto === this.state.currentPhoto)
  {
    selectedPhoto = this.state.imgList[Math.floor(Math.random()*this.state.imgList.length)];

    for (let i = 0; i < this.state.prevSelectedArr.length; i++){
      if(selectedPhoto === this.state.prevSelectedArr[i]){
        selectedPhoto = this.state.imgList[Math.floor(Math.random()*this.state.imgList.length)];
      }
      if(selectedPhoto === this.state.prevSelectedArr[i]){
        selectedPhoto = this.state.imgList[Math.floor(Math.random()*this.state.imgList.length)];
      }
    }
    this.state.prevSelectedArr.push(selectedPhoto);

    if(this.state.prevSelectedArr.length === this.state.imgList.length){
      this.setState({prevSelectedArr: []});
    }

  }

  //We update state with new photo
  this.setState({
    currentPhoto: selectedPhoto
  });


}    




render()
{
    return(
      <div  className = "Carousel">
        <div className= "CarouselImage" style={{background:this.state.path}}>
        </div>
        <div className="imgWrapper"> <div className="img" style={{backgroundImage:"url(" + this.state.currentPhoto + ")"}}></div> </div>
   
        {this.props.auth === true && <button className="btn btno btn-info" onClick={this.modalPop}> Modal </button> }
        {this.state.showModal === true && <CarouselModal  showModal={this.state.showModal} /> } 
       
      </div>
    )
};

}
export default Carousel;



// WEBPACK FOOTER //
// ./src/Components/Carousel/Carousel.js